// extracted by css-extract-rspack-plugin
export default {"video":"aiHy2","video-fade-in":"SxHwU","videoFadeIn":"SxHwU"};